// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteConfirmationModal_dialog__2PRL3"};